// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from "../../../config/styles";

const styles = (theme) => ({
  mainContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 70,
  },
  subContainer: {
    width: "70%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down(750)]: {
      width: "90%",
    },
  },
  title: {
    color: GlobalStyles.color.COLOR_SECONDARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MAX,
    width: "fit-content",
    marginBottom: 20,
  },
  rulesContainer: {
    padding: 15,
  },
  photoDescriptionContainer: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    width: "130%",
    [theme.breakpoints.down(750)]: {
      width: "100%",
    },
  },

  paragraphsContainer: {
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
  },
  paragraphTitle: {
    color: GlobalStyles.color.COLOR_SECONDARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE,
    textAlign: "center",
    width: "100%",
  },
  paragraphText: {
    "& b": {
      fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    },
  },
  paragraphContainer: {
    display: "flex",
    flexDirection: "column",
  },
});

export default styles;
